import { yupResolver } from "@hookform/resolvers/yup";
import {
  Alert,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Stack,
  TextField,
  Dialog,
} from "@mui/material";
import { Box } from "@mui/system";
import { useForm } from "react-hook-form";
import { StyledButton } from "../../../common/components/Button";
import * as yup from "yup";
import { useState } from "react";
import { axios } from "../../../lib/axios";
import { useDispatch } from "react-redux";
import { setNewDentist, removeUser } from "../../../redux/slices/userSlice";
import { logout } from "../../../api/authApi";

const NewDentistDialog = ({ username }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
    clearErrors,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        currentPassword: yup
          .string("Enter a valid password")
          .required("Current password is required"),
        newPassword: yup
          .string("Enter a valid password")
          .min(8, "New password must be 8 characters or longer")
          .matches(
            /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
            "Password must have 1 number, uppercase letter, lowercase letter, and special character"
          )
          .notOneOf(
            [yup.ref("currentPassword"), null],
            "New password should not match current password"
          )
          .required("New password is required"),
        confirmPassword: yup
          .string("Enter a valid password")
          .oneOf([yup.ref("newPassword"), null], "Passwords don't match")
          .required("Confirm password is required"),
      })
    ),
  });

  const handleNewPasswordSubmit = async (values) => {
    setLoading(true);
    clearErrors("submission");
    const passwordDetails = {
      username,
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    };

    try {
      const { data } = await axios.put("auth/password", passwordDetails);
      dispatch(setNewDentist(false));

      if (data.statusCode !== 10) {
        throw new Error(data.error.message);
      }
    } catch (err) {
      setError("submission", { type: "custom", message: err.message });
    }
  };

  const handleLogout = async () => {
    await logout();
    localStorage.clear();
    dispatch(removeUser());
    window.open = "/";
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={true}>
      {isLoading === true && <LinearProgress />}
      <form onSubmit={handleSubmit(handleNewPasswordSubmit)}>
        <DialogTitle>Change password</DialogTitle>
        <DialogContent>
          <Box fontSize="0.875em">
            Please change the default password we provided for you
          </Box>
          {errors.submission && (
            <Alert severity="error" sx={{ marginY: 1 }}>
              {errors.submission.message}
            </Alert>
          )}
          <Stack spacing={2} sx={{ paddingY: 2 }}>
            <TextField
              label="Current Password"
              id="currentPassword"
              variant="outlined"
              type="password"
              error={errors.currentPassword}
              helperText={errors.currentPassword?.message}
              {...register("currentPassword")}
            />
            <TextField
              label="New Password"
              id="newPassword"
              variant="outlined"
              type="password"
              error={errors.newPassword}
              helperText={errors.newPassword?.message}
              {...register("newPassword")}
            />
            <TextField
              label="Confirm Password"
              id="confirmPassword"
              variant="outlined"
              type="password"
              error={errors.confirmPassword}
              helperText={errors.confirmPassword?.message}
              {...register("confirmPassword")}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Box sx={{ paddingBottom: 1 }}>
            <StyledButton theme="green" type="button" onClick={handleLogout}>
              Logout
            </StyledButton>
            <StyledButton theme="green" type="submit" sx={{ marginLeft: 2 }}>
              Submit
            </StyledButton>
          </Box>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default NewDentistDialog;
